import { PayloadAction } from '@reduxjs/toolkit';
import type { ImportAutoConfiguratorDataResponse } from '@snap-types/actions/import-auto-configurator-data';

import { WritableAutoConfiguratorState } from '../slice';

type SetLastImportResultPayload = {
  siteCode: string;
  result: ImportAutoConfiguratorDataResponse | null;
};

export function setLastImportResult(
  state: WritableAutoConfiguratorState,
  action: PayloadAction<SetLastImportResultPayload>,
) {
  const normalizedSiteCode = action.payload.siteCode.toLowerCase();
  const { result } = action.payload;

  if (!result) {
    delete state.lastImportResultsBySiteCode[normalizedSiteCode];
    delete state.lastImportUuidsBySiteCode[normalizedSiteCode];

    return;
  }

  state.lastImportResultsBySiteCode[normalizedSiteCode] = result;
  state.lastImportUuidsBySiteCode[normalizedSiteCode] = result.dataImport.uuid;
}
